<template>
    <v-card class="mx-auto" max-width="600" color="transparent" elevation="0" flat>
        <v-row class="mt-5" no-gutters>
            <v-col cols="12" class="d-flex justify-start align-center">
                <v-btn x-large icon @click="$router.push('/user')">
                    <v-icon color="#343434">mdi-chevron-left</v-icon>
                </v-btn>
                <span class="h6 mb-0">Timestop</span>
            </v-col>
        </v-row>
        <v-row v-if="loading" no-gutters>
            <v-col cols="12">
                <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-col>
        </v-row>
        <v-row v-else-if="!loadingError" no-gutters>
            <v-col cols="12" class="text-center">
                <v-btn @click="showNewDialog = true" color="primary">Neuen Timestop erfassen</v-btn>
            </v-col>
            <v-col cols="12" class="px-0">
                <v-card-title>Existierende Timestops</v-card-title>
            </v-col>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-alert class="ma-auto" type="info" v-if="!userTimestops.length">Keine Timestops gefunden</v-alert>
                </v-col>
                <v-col v-for="timestop of userTimestops" :key="timestop._id" cols="12" class="mt-2">
                    <v-card @click="test(timestop)">
                        <v-card-title class="h6 font-weight-bold">
                            Erstellt am {{ $moment(timestop.createdAt).format('DD.MM.YYYY HH:mm') }}
                            <v-chip class="ml-2 white--text" :color="timestopStateColorMap[timestop.status]">
                                {{ timestopStateMap[timestop.status] }}
                            </v-chip>
                        </v-card-title>
                        <v-card-subtitle>
                            Timestop von:
                            {{
                                $moment(timestop.tacData.TimeSpan.Start).format('DD.MM.YYYY') +
                                ' - ' +
                                $moment(timestop.tacData.TimeSpan.End).format('DD.MM.YYYY') +
                                ' (' +
                                timestop.tacData.Duration +
                                ' Tage)'
                            }}
                            <br />
                            <span v-if="timestop.status !== 'onHold'">
                                {{ timestop.status === 'accepted' ? 'Kosten:' : 'Vorraussichtliche Kosten:' }}
                                {{ timestop.tacData.IdlePeriodFee.value }}
                            </span>

                            <v-alert v-if="timestop.status === 'open'" type="info">
                                Dein Timestop wird aktuell von uns bearbeitet. Sobald wir diesen abgeschlossen haben,
                                wirst du, falls aktiviert, eine Push-Nachricht bekommen und zusätzlich wird eine Mail
                                versendet.
                            </v-alert>

                            <v-alert v-if="timestop.status === 'onHold'" type="warning">
                                Bei deiner Anfrage für einen Timestop wurden Änderungen vorgenommen.
                                <br />
                                {{ timestopStateMap[timestop.changeLog[timestop.changeLog.length - 2].state] }} =>
                                {{ timestopStateMap[timestop.changeLog[timestop.changeLog.length - 1].state] }}
                                <br />
                                {{ timestop.changeLog[timestop.changeLog.length - 2].fee + ' CHF' }} =>
                                {{ timestop.changeLog[timestop.changeLog.length - 1].fee + ' CHF' }}
                            </v-alert>

                            <v-alert v-if="timestop.status === 'rejected'" type="error">
                                Deine Anfrage für einen Timestop wurde abgelehnt. Wir bitten dich darum, eine neue
                                Anfrage einzureichen.
                                <br />
                                <br />
                                <span class="font-weight-bold">Grund:</span>
                                <br />
                                {{ timestop.officeNote }}
                            </v-alert>
                        </v-card-subtitle>
                        <v-card-actions v-if="timestop.status === 'onHold'" class="justify-content-center text-center">
                            <v-btn color="primary" @click="acceptChangesTimestop = timestop">
                                Änderungen akzeptieren
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-row>
        <v-row v-else no-gutters>
            <v-col cols="12">
                <v-alert type="error" elevation="2" icon="mdi-alert-circle-outline">
                    Diese Funktion ist nicht verfügbar
                </v-alert>
            </v-col>
        </v-row>
        <user-timestop-form
            @onClose="closeNewDialog"
            @onSuccess="closeNewDialog"
            :newEntry="true"
            :visible="showNewDialog"
        ></user-timestop-form>
        <payment-dialog v-if="createPayment"></payment-dialog>
        <v-dialog @click:outside="acceptChangesTimestop = null" :value="!!acceptChangesTimestop">
            <v-card v-if="acceptChangesTimestop">
                <v-card-title>Ich akzeptiere die Änderungen</v-card-title>
                <signature-pad
                    class="mx-auto"
                    autoSaveSignature
                    :signature-data="acceptChangesTimestop.customerInfos.signature"
                    @startDrawing="signature = true"
                    @saveSignature="saveSignature"
                    ref="signatureConditions"
                ></signature-pad>
                <v-card-actions class="justify-content-center">
                    <v-btn color="primary" @click="updateTimestop()">Bestätigen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import UserTimestopForm from './UserTimestopForm.vue'
import PaymentDialog from '../../payment/paymentDialog.vue'
import signaturePad from '@/components/signaturePad/signaturePad.vue'

import api from '@/api'
export default {
    components: {
        signaturePad,
        UserTimestopForm,
        PaymentDialog,
    },
    props: {
        studios: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            timestopStateMap: {
                open: 'Offen',
                accepted: 'Akzeptiert',
                rejected: 'Abgelehnt',
                onHold: 'Bestätigung erforderlich',
                withAttest: 'mit Attest',
                withoutAttest: 'ohne Attest',
                officeChangedFee: 'Sondergebühr',
            },
            timestopStateColorMap: {
                open: 'blue',
                accepted: 'primary',
                rejected: 'red',
                onHold: 'orange',
            },
            signature: false,
            acceptChangesTimestop: null,
            userTimestops: [],
            loading: true,
            loadingError: false,
            timestopText: '',
            showNewDialog: false,
            createPayment: false,
        }
    },
    created() {
        this.getAllTimestops()
    },
    methods: {
        test(x) {
            console.log(x)
        },
        saveSignature(e) {
            console.log(e)
            this.acceptChangesTimestop.customerInfos.signature = e
        },
        async updateTimestop() {
            if (!this.acceptChangesTimestop.customerInfos.signature) return this.$toast.error('Unterschrift hinzufügen')
            this.acceptChangesTimestop.status = 'open'
            let upated = await api.updateTimeStopFormEntry(this.acceptChangesTimestop)
            this.acceptChangesTimestop = null
            await this.getAllTimestops()
        },
        createTACPayment() {
            this.createPayment = true
            console.log('erstelle neue zahlung')
        },
        showTimestop() {
            this.showNewDialog = true
        },

        async getAllTimestops() {
            try {
                this.loading = true
                let timestops = await api.fetchAllTimestopsForUser()
                this.userTimestops = await Promise.all(
                    timestops.map(async (timestop) => {
                        timestop.customerInfos.signature = null
                        if (!timestop.changeLog) timestop.changeLog = []
                        timestop.initialFee = JSON.parse(JSON.stringify(timestop.tacData.IdlePeriodFee.value))
                        if (timestop.officeChangedFee) {
                            timestop.officeChangedFeeAmount = timestop.tacData.IdlePeriodFee.value || 0
                            timestop.initialState = 'officeChangedFee'
                        } else {
                            timestop.initialState = timestop.withAttest ? 'withAttest' : 'withoutAttest'
                        }
                        timestop.changeLog.push(
                            JSON.parse(
                                JSON.stringify({
                                    state: timestop.initialState,
                                    fee: timestop.initialFee,
                                    note: timestop.officeNote,
                                })
                            )
                        )
                        return timestop
                    })
                )
                this.loadingError = false
                this.loading = false
            } catch (e) {
                this.$toast.error('Fehler beim laden der Timestops')
            }
        },
        async downloadPDF(id) {
            try {
                await api.fetchTimestopPDF(id)
            } catch (e) {}
        },
        closeNewDialog() {
            this.showNewDialog = false
            this.getAllTimestops()
        },
    },
    watch: {
        studios() {},
    },
}
</script>